<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/xllh/rpqnrcyz.png" alt="" />
      <div class="technological-process">
        <div class="zcjj">
          <img class="top" src="./../assets/imgs/xllh/newtitle.png" alt="" />
          <div class="content">
            <div class="des">
              为深入贯彻落实市委人才优先发展战略，团市委按照《成都实施人才优先发展战略行动计划》工作安排，建设“蓉漂”青年人才驿站，为在蓉求职应聘的青年大学生提供不少于7天的免费短期住宿。青年人才驿站配备完善的生活设施，提供政策解读、岗位推介、城市融入等温馨的增值服务，让青年人才驿站真正成为“蓉漂”青年来到成都的第一个港湾。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/rprcyz/rprcyz-2.png" alt="" />
          <div class="content">
            <div class="des">
              本科及以上学历在蓉求职青年大学生（部分驿站放宽至专科及以上学历，应届毕业生优先）
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="./../assets/imgs/xllh/rpqnrcyz_zcnr.png"
            alt=""
          />
          <div class="content">
            <div class="des">
              <img
                class="title-img"
                src="./../assets/imgs/xllh/rpqnrcyz_zsbz.png"
                alt=""
              />
              享受7—30天内免费短期住宿（单次最长申请7天，可根据驿站实际情况申请续住）。
            </div>
            <div class="des">
              <img
                class="title-img"
                src="./../assets/imgs/xllh/rpqnrcyz_zzfw.png"
                alt=""
              />
              享受政策解读、岗位推介、城市融入、青年社交等配套增值服务。
            </div>
          </div>
        </div>
        <div class="part-four">
          <img
            src="../assets/imgs/wuhou/1/title3.png"
            class="part-two-title-img"
          />
          <div class="main-content">
            <div class="part-four-items">
              <div class="title-bg">填写资料</div>
              <div class="part-four-content1">
                申请人需根据入住时间提前登陆成都青年人才驿站官网（https://home.cdcyl.org.cn
                ），选择入住站点，详细阅读《申请入住须知》，填写相关信息，上传相关证明材料（身份证、毕业证、学生证、学位证、在蓉应聘书等），完成注册申请。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">提交入住申请</div>
              </div>
              <div class="part-four-content1">
                申请人成功提交申请后，系统自动向区（市）县驿站管理员发送入住申请短信通知，区（市）县驿站管理员收到短信通知后24小时内，完成提交入住申请信息的审核。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg3">通知入住</div>
              <div class="part-four-content1">
                审核通过后，系统自动向申请人发送入住申请成功短信，通知入住时间、地点；如未通过，则会向申请人说明情况。
              </div>
            </div>
          </div>
        </div>
        <div class="contact">
          <img class="top" src="./../assets/imgs/xllh/title4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-61310932">028-61310932</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              团市委青年发展部
            </div>
          </div>
        </div>
        <div class="contact">
          <img class="top" src="./../assets/imgs/xllh/title5.png" alt="" />
          <div class="content">
            <div class="ct">
              <div class="ct-circle"></div>
              驿站官网
            </div>
            <div
              style="
                color: #1f78ff;
                padding-left: 0.4rem;
                margin-bottom: 0.34rem;
              "
            >
              <a href="http://home.cdcyl.org.cn">http://home.cdcyl.org.cn</a>
            </div>
            <div class="ct">
              <div class="ct-circle"></div>
              微信公众号
            </div>
            <div class="sqsj">
              <img src="./../assets/imgs/rprcyz/code.png" class="code" alt="" />
              <img
                src="./../assets/imgs/rprcyz/code-info.png"
                class="info"
                alt=""
              />
            </div>
          </div>
        </div>

        <!-- <bottom
                            phone="028-61310932"
                            unit="共青团成都市委青年发展部"
                        ></bottom> -->
      </div>
    </section>
    <call site="https://home.cdcyl.org.cn/web-sys-inn" goIndex="1"></call>
  </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    // bottom,
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.ct {
  font-size: 0.34rem;
  color: #333333;
  margin-bottom: 0.14rem;
  display: flex;
  align-items: center;
  &-circle {
    width: 0.16rem;
    height: 0.16rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
    margin-right: 0.12rem;
  }
}

.xlrclh {
  background-color: $base-back;
  padding-bottom: 0.1rem;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-1.9rem);

    .zcjj {
      .top {
        width: 6.68rem;
        height: 2.12rem;
      }

      .content {
        width: 6.68rem;
        background: #ffffff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.33rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        line-height: 0.44rem;
        .title {
          font-size: 0.34rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;
          text-align: left;
          margin-top: 0.16rem;
        }
      }
    }

    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        // padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem 0.35rem 0.4rem;
          text-align: left;
          line-height: 0.44rem;
          position: relative;

          img {
            position: absolute;
            width: 1.74rem;
            height: 0.6rem;
            top: 0;
            left: 0;
          }
        }
      }
    }

    .zcnr {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem 0.3rem;
          text-align: left;
          line-height: 0.44rem;
          position: relative;
        }

        .rcajewm {
          margin-top: 0.36rem;
          width: 6.15rem;
          height: 1.52rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.68rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          line-height: 0.44rem;

          .title-img {
            position: absolute;
            left: 50%;
            top: 0rem;
            width: 2.52rem;
            height: 0.67rem;
            transform: translate(-50%, -50%);
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-top {
              display: flex;

              .line-num {
                min-width: 0.39rem;
                height: 0.39rem;
                background: #739bfe;
                color: #ffffff;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }

          .des-item {
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            padding-left: 0.33rem;
            padding-top: 0.22rem;
            margin-left: 0.2rem;
            border-left: 0.02rem dashed #739bfe;
            padding-bottom: 0.55rem;

            .cdrcwewm {
              width: 5.51rem;
              height: 1.43rem;
              margin-top: 0.16rem;
            }
          }

          .describe-item {
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            padding-left: 0.33rem;
            padding-top: 0.22rem;
            margin-left: 0.2rem;
            word-break: break-all;
          }
        }
      }
    }

    .part-four {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 10px;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 0.22rem;
      border: 0.00001px solid transparent;
      position: relative;
      padding: 1.2rem 0.25rem 0 0.25rem;
      .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.2rem;
        position: absolute;
      }
      .main-content {
        margin-top: 0.34rem;
        width: 6.35rem;
        background: #ffffff;
        border-radius: 10px;
        box-sizing: border-box;
        padding-top: 0.9rem;
        padding-left: 0.35rem;
        padding-right: 0.31rem;

        .part-four-items {
          box-sizing: border-box;
          border-left: 0.02rem dashed #739bfe;
          margin-bottom: 0.6rem;
          padding-left: 0.33rem;
          padding-top: 0.2rem;
          position: relative;
          font-size: 0.26rem;
          // //font-family:: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;
          text-align: left;
          padding-bottom: 0.35rem;

          .title-bg {
            position: absolute;
            width: 3.31rem;
            height: 0.55rem;
            top: -0.6rem;
            left: -0.25rem;
            line-height: 0.55rem;
            font-size: 0.34rem;
            font-weight: bold;
            color: #3d5aa3;
            padding-left: 0.58rem;
            background: url(../assets/imgs/144/p1.png) 0 0/100% 100%;
            border: 1px solid #fff;
          }

          .title-bg2 {
            background: url(../assets/imgs/144/p2.png) 0 0/100% 100%;
          }

          .extendFont {
            min-width: 7rem;
            position: absolute;
            top: 50%;
            left: 0.58rem;
            transform: translateY(-50%);
          }

          .title-bg3 {
            background: url(../assets/imgs/144/p3.png) 0 0/100% 100%;
          }

          .title-bg4 {
            background: url(../assets/imgs/144/p4.png) 0 0/100% 100%;
          }

          .title-bg5 {
            background: url(../assets/imgs/144/p5.png) 0 0/100% 100%;
          }

          .title-bg6 {
            background: url(../assets/imgs/144/p6.png) 0 0/100% 100%;
          }

          .inside-title {
            font-weight: 800;
          }

          .part-four-content2 {
            font-weight: bolder;
          }
        }
      }
    }

    .sqsj {
      // width: 6.85rem;
      height: 2.45rem;
      background: #ffffff;
      border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
      // margin: 0.3rem auto 0;
      // padding-top: 0.3rem;
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 0.18rem;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .info {
        width: 3.88rem;
        height: 0.96rem;
      }
    }

    .zrdw {
      font-size: 0.24rem;
      font-weight: 500;
      color: #97a9d9;
      margin-top: 0.16rem;
    }

    .zxdh {
      font-size: 0.24rem;
      font-weight: 500;
      color: #97a9d9;
      line-height: 0.28rem;
    }

    .phone-list {
      margin-top: 0.36rem;

      img {
        width: 6.85rem;
        height: 14.93rem;
      }
    }
  }
}
</style>
